<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <img src="/assets/images/account-create.png" class="w-100 mt-0 mt-md-5 pt-0 pt-md-5" />
        </div>
        <div class="col-md-1"></div>
        <div class="col-lg-7">
          <p class="text-color font-size-30 font-weight-500 mt-4">
            CREATE NEW ACCOUNT
          </p>
          <p class="text-change font-size-15 font-weight-500">
            Fill the form to register your new account.
          </p>
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                (click)="signUpUser('patientSignUp')" checked="true" value="patientSignUp" />
              <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio1">Patient</label>
            </div>
            <div class="form-check form-check-inline ml-5">
              <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                (click)="signUpUser('clinicSignUp')" value="clinicSignUp" />
              <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio2">Healthcare
                Provider</label>
            </div>
          </div>
          <div *ngIf="currentLogin === 'clinicSignUp'">
            <div class="md-stepper-horizontal orange mb-3">
              <div class="md-step" [ngClass]="{ active: step === 1 }">
                <!--<div class="md-step-circle"><span>1</span></div> -->
                <div class="md-step-title">Admin Profile</div>
                <div class="md-step-bar-left"></div>
                <div class="md-step-bar-right"></div>
              </div>
              <!--  <div class="md-step" [ngClass]="{'active': step === 2}">
                <div class="md-step-circle"><span>2</span></div>
                <div class="md-step-title">Organization Profile</div>
                <div class="md-step-bar-left"></div>
                <div class="md-step-bar-right"></div>
              </div> -->
            </div>

            <form #userForm="ngForm" *ngIf="step === 1">
              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">First Name<span
                      class="text-danger">*</span></label>
                  <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="user.first_name" name="first_name"
                    #first_name="ngModel" class="form-control" placeholder="First Name" />
                  <div class="text-danger" *ngIf="first_name.touched && !first_name.valid">
                    *First name is required & should be alpahbets only
                  </div>
                </div>
                <div class="col-md-6 mt-2 mt-md-0">
                  <label for="name" class="ptext-change font-weight-500">Last Name<span
                      class="text-danger">*</span></label>
                  <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="user.last_name" name="last_name"
                    #last_name="ngModel" class="form-control" placeholder="Last Name" />
                  <div class="text-danger" *ngIf="last_name.touched && !last_name.valid">
                    *Last name is required & should be alpahbets only
                  </div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Mobile Number<span
                      class="text-danger">*</span></label>
                  <input type="text" maxlength="12" pattern="[0-9\s]+" required [(ngModel)]="user.contact_no"
                    name="contact_no" #contact_no="ngModel" class="form-control" placeholder="Contact number" min="0"
                    minlength="10" maxlength="10" />
                  <div class="text-danger" *ngIf="contact_no.touched && !contact_no.valid">
                    *This must be a valid number & it's required
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Your Email<span
                      class="text-danger">*</span></label>
                  <input id="email_id" on-focusout="checkEid()" [pattern]="emailpat" type="text" required
                    [(ngModel)]="user.email_id" name="email_id" #email_id="ngModel" class="form-control"
                    placeholder="Your Email(Active)" autocomplete="off" />
                  <div class="text-danger" *ngIf="email_id.touched && !email_id.valid">
                    *Enter a valid Email-id for which account activation link
                    will be sent
                  </div>
                  <div [innerHTML]="innerHtml"></div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Password<span
                      class="text-danger">*</span></label>
                  <div class="inputWithIcon position-relative">
                    <input ng required [(ngModel)]="user.password0" name="password0" #password0="ngModel"
                      class="form-control" [type]="isMutePass ? 'text' : 'password'" autocomplete="new-password"
                      placeholder="Password" [pattern]="passwordRegex" />
                    <i class="fa text-color-font fa-lg position-absolute cursor" [ngClass]="{
                        'fa-eye': isMutePass,
                        'fa-eye-slash': !isMutePass
                      }" (click)="isMutePass = !isMutePass"></i>
                  </div>
                  <div class="text-danger" *ngIf="password0.touched && password0.errors?.required">
                    *Password is required
                  </div>

                  <div class="text-danger" *ngIf="password0.touched && password0.errors?.pattern">
                    *Password should be atleast 8 characters, should contain one
                    uppercase letter, one lowercase letter, one special
                    character (from <b> !@#$%^&()* </b>) and one number.
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Confirm Password<span
                      class="text-danger">*</span></label>
                  <div class="inputWithIcon position-relative">
                    <input [type]="isMutePass2 ? 'text' : 'password'" required [(ngModel)]="user.password"
                      #password="ngModel" name="password" class="form-control" placeholder="Confirm Password"
                      autocomplete="new-password" />
                    <i class="fa text-color-font fa-lg position-absolute cursor" [ngClass]="{
                        'fa-eye': isMutePass2,
                        'fa-eye-slash': !isMutePass2
                      }" (click)="isMutePass2 = !isMutePass2"></i>
                  </div>
                  <div class="text-danger" *ngIf="password.touched && password.errors?.required">
                    *Confirm Password is required.
                  </div>
                  <div class="text-danger" *ngIf="
                      password.touched &&
                      user.password.length > 0 &&
                      userForm.value.password !== userForm.value.password0
                    ">
                    *Password mismatch
                  </div>
                </div>
              </div>
              <div class="form-check pt-3">
                <input type="checkbox" class="form-check-input" id="termsnCondition" (change)="tacChecked($event)"
                  required />
                <label class="form-check-label ml-2" for="exampleCheck1">I accept<a href="{{ termsUrl }}"
                    class="text-primary" target="_blank">
                    terms and condition</a></label>
              </div>
              <div class="row pt-3 mt-3">
                <div class="col-md-12">
                  <button type="button" class="btn btn-primary btn-lg w-100 mb-4" [disabled]="
                      !userForm.valid ||
                      innerHtml ||
                      userForm.value.password !== userForm.value.password0 ||
                      termsAndCondition == false
                    " (click)="createAdminProfile()">
                    Create Account
                  </button>
                </div>
              </div>
            </form>
            <!--
            <form #orgForm="ngForm" *ngIf="step === 2">

              <div class="row pt-3">


                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Organization Name<span
                      class="text-danger">*</span></label>
                  <input type="text" pattern="[a-zA-Z0-9\s]+" required [(ngModel)]="organisation.oname" name="oname"
                    #oname="ngModel" class="form-control" placeholder="Organization Name" required />
                  <div class="text-danger" *ngIf="oname.touched && !oname.valid">
                    *This Field is required, Must be
                    Alphabets
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Organization Email-id<span
                      class="text-danger">*</span></label>
                  <input type="text" required [(ngModel)]="organisation.org_eid" name="org_eid" #org_eid="ngModel"
                    class="form-control" placeholder="Organisation Email-id" [pattern]="emailpat" />
                  <div class="text-danger" *ngIf="org_eid.touched && !org_eid.valid">
                    <span *ngIf="org_eid?.errors?.required"> *This field is required</span>
                    <span *ngIf="org_eid?.errors?.pattern"> *This field is invalid</span>
                  </div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Organization Address Line 1<span
                      class="text-danger">*</span></label>
                  <input type="text" required [(ngModel)]="organisation.address1" name="address1" #address1="ngModel"
                    class="form-control" placeholder="Address Line 1" />
                  <div class="text-danger" *ngIf="address1.touched && !address1.valid">
                    *This field is required
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Organization Address Line 2<span
                      class="text-danger"></span></label>
                  <input type="text" [(ngModel)]="organisation.address2" name="address2" #address2="ngModel"
                    class="form-control" placeholder="Address Line 2 (Optional)" />
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">City<span class="text-danger">*</span></label>
                  <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="organisation.city" name="city"
                    #city="ngModel" class="form-control" placeholder="City" />
                  <div class="text-danger" *ngIf="city.touched && !city.valid">
                    *This field is required & allows Alphabets only
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">State<span class="text-danger">*</span></label>
                  <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="organisation.state" name="state"
                    #state="ngModel" class="form-control" placeholder="State" />
                  <div class="text-danger" *ngIf="state.touched && !state.valid">
                    *This field is required & allows
                    Alphabets only
                  </div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Zip Code<span
                      class="text-danger">*</span></label>

                  <input type="number" required [(ngModel)]="organisation.zip" name="zip" #zip="ngModel"
                    class="form-control" placeholder="Zip Code" min="0" [pattern]="zipRegex" />
                  <div class="text-danger" *ngIf="zip.touched && !zip.valid">
                    <span *ngIf="zip?.errors?.required">*This field is required</span>
                    <span *ngIf="zip?.errors?.pattern">*This field is invalid</span>
                  </div>
                </div>

              </div>

              <div class="row pt-3 mt-3">
                <div class="col-md-12">
                  <button class="btn btn-primary btn-lg w-100 mb-4" type="button" (click)="addOrg()"
                    [disabled]="!orgForm.valid" name="submit">
                    Confirm
                  </button>
                </div>
              </div>

            </form> -->
          </div>
          <div *ngIf="currentLogin === 'patientSignUp'">
            <form [formGroup]="patientForm">
              <div class="row pt-3">
                <div class="form-group col-md-6">
                  <label for="name" class="text-change font-weight-500">First Name<span
                      class="text-danger">*</span></label>
                  <input type="text" formControlName="first_name" class="form-control" placeholder="First Name"
                    maxLength="30" required />
                  <div *ngIf="patientForm.get('first_name').hasError('required')" class="invalid-feedback">
                    First Name is required
                  </div>
                  <div *ngIf="patientForm.get('first_name').hasError('pattern')" class="invalid-feedback">
                    First Name is invalid
                  </div>
                  <div class="text-danger"
                    *ngIf="patientForm.get('first_name').touched && !patientForm.get('first_name').valid">
                    *First name is required & should be alphabets only
                  </div>
                </div>
                <div class="form-group col-md-6 mt-2 mt-md-0">
                  <label for="name" class="ptext-change font-weight-500">Last Name<span
                      class="text-danger">*</span></label>
                  <input type="text" formControlName="last_name" class="form-control" placeholder="Last Name"
                    maxLength="30" required />
                  <div *ngIf="patientForm.get('last_name').hasError('required')" class="invalid-feedback">
                    Last Name is required
                  </div>
                  <div *ngIf="patientForm.get('last_name').hasError('pattern')" class="invalid-feedback">
                    Last Name is invalid
                  </div>
                  <div class="text-danger"
                    *ngIf="patientForm.get('last_name').touched && !patientForm.get('last_name').valid">
                    *Last name is required & should be alphabets only
                  </div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="form-group col-md-6">
                  <label for="name" class="text-change font-weight-500">Date of Birth<span
                      class="text-danger">*</span></label>
                  <div class="d-flex">
                    <input maxlength="10" [type]="date" class="form-control" placeholder="Date of Birth (DD/MM/YYYY)"
                      name="dob" formControlName="dob" ngbDatepicker #sd="ngbDatepicker"
                      (dateSelect)="dateTimeChangeEvent($event)" data-date-inline-picker="false" id="dob"
                      [minDate]="miniDate" [maxDate]="currentDate" />
                    <div>
                      <button class="btn btn-outline-secondary calendar rounded-0" (click)="sd.toggle()" type="button"
                        style="line-height: 2.5;" id="startDateButton">
                        <span class="fa fa-calendar"></span>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="patientForm.get('dob').hasError('required')" class="invalid-feedback"> Start Date is
                    required
                  </div>
                  <div class="text-danger" *ngIf="patientForm.get('dob').touched && !patientForm.get('dob').valid">
                    *DOB is required
                  </div>
                  <!-- <div m-t-10>
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                        placeholder="Choose a date" formControlName="dob" readonly required />
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      <mat-error *ngIf="patientForm.get('dob').errors">
                        <div *ngIf="
                            patientForm.get('dob').hasError('required') &&
                            !(
                              patientForm
                                .get('dob')
                                .hasError('matDatepickerMax') ||
                              patientForm
                                .get('dob')
                                .hasError('matDatepickerMin') ||
                              patientForm
                                .get('dob')
                                .hasError('matDatepickerParse')
                            )
                          ">
                          DOB is required
                        </div>
                        <div *ngIf="
                            patientForm
                              .get('dob')
                              .hasError('matDatepickerMax') ||
                            patientForm.get('dob').hasError('matDatepickerMin')
                          ">
                          DOB is invalid
                        </div>
                      </mat-error>
                    </mat-form-field>
                  </div> -->
                </div>
                <div class="col-md-6">
                  <label for="name" class="text-change font-weight-500">Gender<span class="text-danger">*</span></label>
                  <select class="form-control" formControlName="gender">
                    <option *ngFor="let g of gender" [value]="g.value">
                      {{ g.key }}
                    </option>
                  </select>
                  <div *ngIf="patientForm.get('gender').hasError('required')" class="invalid-feedback">
                    Gender is required
                  </div>
                  <div class="text-danger"
                    *ngIf="patientForm.get('gender').touched && !patientForm.get('gender').valid">
                    *Gender is required
                  </div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="form-group col-md-6">
                  <label for="name" class="text-change font-weight-500">Your Email<span
                      class="text-danger">*</span></label>
                  <input id="email_id" type="text" name="email_id" formControlName="email_id" class="form-control"
                    placeholder="Your Email(Active)" maxLength="50" required />
                  <div *ngIf="patientForm.get('email_id').hasError('required')" class="invalid-feedback">
                    Email is required
                  </div>
                  <div *ngIf="patientForm.get('email_id').hasError('pattern')" class="invalid-feedback">
                    Email is invalid
                  </div>
                  <div class="text-danger"
                    *ngIf="patientForm.get('email_id').touched && !patientForm.get('email_id').valid">
                    *Email is required & should be valid
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="name" class="text-change font-weight-500">Confirm Email<span
                      class="text-danger">*</span></label>
                  <input id="confirm_email" type="text" formControlName="confirm_email" class="form-control"
                    placeholder="Confirm Email" maxLength="50" on-focusout="emailvalid(confirmationModal)" required />
                  <div *ngIf="
                      patientForm.get('confirm_email').hasError('required')
                    " class="invalid-feedback">
                    Confirm Email is required & should be valid
                  </div>
                  <div *ngIf="
                      patientForm
                        .get('confirm_email')
                        .hasError('confirmedValidator')
                    " class="invalid-feedback">
                    Confirm email should be same.
                  </div>
                  <div class="text-danger"
                    *ngIf="patientForm.get('confirm_email').touched && !patientForm.get('confirm_email').valid">
                    *Confirm Email is required and same as You given
                  </div>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label for="phone" class="text-change font-weight-500">Your Phone<span
                      class="text-danger">*</span></label>
                  <input id="contact_no" type="text" class="form-control" formControlName="contact_no" maxLength="10"
                    minLength="10" required on-focusout="requestOTP()" />
                  <div *ngIf="patientForm.get('contact_no').hasError('required')" class="invalid-feedback">
                    Phone is required
                  </div>
                  <!-- <div *ngIf="
                      patientForm.get('contact_no').hasError('pattern') ||
                      patientForm.get('contact_no').hasError('minlength')
                    " class="invalid-feedback">
                    Phone is invalid
                  </div> -->
                  <!-- <div class="text-danger"
                    *ngIf="patientForm.get('contact_no').touched && !patientForm.get('contact_no').valid">
                    *Contact no is required
                  </div> -->
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-6">
                  <label class="font-weight-500">OTP<span class="text-danger">*</span></label>
                  <input id="otp" type="password" class="form-control" formControlName="otp" maxLength="6" required
                    on-focusout="validateOTP()" autocomplete="new-password" />
                  <div *ngIf="patientForm.get('otp').hasError('required')" class="invalid-feedback">
                    OTP is required
                  </div>
                  <div *ngIf="patientForm.get('otp').touched && wrongOTP" class="invalid-feedback">
                    OTP is invalid
                  </div>
                </div>
              </div>
              <div class="form-check pt-3">
                <input type="checkbox" class="form-check-input" id="exampleCheck1" (change)="tacChecked($event)"
                  required />
                <label class="form-check-label ml-2" for="exampleCheck1">I accept<a href="{{ termsUrl }}"
                    class="text-primary" target="_blank">
                    terms and condition</a></label>
              </div>
              <div class="row pt-3 mt-3">
                <div class="col-md-12">
                  <button type="button" class="btn btn-primary btn-lg w-100 mb-4" [disabled]="
                      !patientForm.valid ||
                      !validOTP ||
                      termsAndCondition == false
                      || disableCheckbok=== true
                    " (click)="createPatientProfile()">
                    Create Account
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>


<ng-template #confirmationModal let-modal>
  <!-- Modal content -->
  <div class="modal-body">
    <span class="close" (click)="modal.dismiss(false)">&times;</span>
    <div class="row center-mobile">
      <div class="col-md-4 m-l-60 m12">
        <i class="fa fa-heartbeat heartbeat" style="font-size: 75px; color: #dc3648; margin-left: 25px;"
          aria-hidden="true"></i>
      </div>
      <div class="col-md-8 m-l-10 m12">
        <p style="margin-bottom: 5px;">Your account already exist, please login to continue</p>

        <div class="row">
          <div class="btnwrap">
            <span>
              <button type="button" class="btn btn-model" (click)="modal.dismiss(false)"
                style="background-color: #6f717d; color: white; margin-right: 10px;     margin-left: 15px;"> No
              </button>
            </span>
            <span>
              <a href=".#/login"> <button type="button" class="btn btn-primary btn-model"
                  (click)="modal.dismiss(false)"> Yes </button></a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>